import React from "react";
import Modal from "react-bootstrap/Modal";
import UpdatePassword from "../components/UpdatePassword";

const UpdatePasswordModal = ({ visible, close, user }) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            Update User Password
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UpdatePassword user={user} onComplete={close} close={close} />
      </Modal.Body>
    </Modal>
  );
};

export default UpdatePasswordModal;
